let hasRequested = false

/**
 * Ask the browser to make IndexedDB storage persistent so chunks survive
 * storage-pressure eviction. Best-effort; safe to call repeatedly.
 */
export async function ensurePersistentStorage(): Promise<void> {
  if (hasRequested) return
  hasRequested = true

  if (typeof navigator === 'undefined') return
  const storage = navigator.storage
  if (!storage || typeof storage.persist !== 'function') return

  try {
    if (typeof storage.persisted === 'function') {
      const already = await storage.persisted()
      if (already) return
    }
    const granted = await storage.persist()
    console.info('[storagePersist] granted:', granted)
  } catch (err) {
    console.warn('[storagePersist] request failed', err)
  }
}
